import React, { useState, useEffect } from 'react';
import { FaPython, FaReact } from "react-icons/fa";
import { SiJavascript, SiMongodb } from "react-icons/si";
import DiscordStatus from './DiscordStatus';
import '../styles/ProfileSection.css';

const ProfileSection = () => {
  const [subtitleText, setSubtitleText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [textPhase, setTextPhase] = useState(0);
  const textPhrases = [
    "an untalented guy that makes stuff", 
    "felony.pro lmao real", 
    "convicted felon in all states", 
    "professional chatgpt user", 
    "real", 
    "deepseek on top!",
    "141."
  ];
  const [volume, setVolume] = useState(55);
  
  // For the greeting typing animation
  const [greetingText, setGreetingText] = useState('');
  const [isDeletingGreeting, setIsDeletingGreeting] = useState(false);
  const [greetingPhase, setGreetingPhase] = useState(0);
  const greetings = [
    "Përshëndetje, I'm jxsh", // Albanian
    "Hello, I'm jxsh", // English
    "Привет, I'm jxsh", // Russian
    "Hola, I'm jxsh", // Spanish
    "こんにちは, I'm jxsh" // Japanese
  ];

  // Set initial volume when component mounts
  useEffect(() => {
    // Find background audio element and set its volume
    const audio = document.querySelector('.background-audio');
    if (audio) {
      audio.volume = volume / 100;
    }
  }, [volume]);

  // Handle volume change
  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    setVolume(newVolume);
    
    // Find background audio element and set its volume
    const audio = document.querySelector('.background-audio');
    if (audio) {
      audio.volume = newVolume / 100;
    }
  };

  // Typing animation effect for greeting
  useEffect(() => {
    const currentGreeting = greetings[greetingPhase];
    
    const typingSpeed = isDeletingGreeting ? 30 : 50; // Delete faster than type
    const pauseDuration = 1500; // Pause before deleting
    
    let timer;
    
    // If the typed text is complete (matches the current greeting)
    if (!isDeletingGreeting && greetingText === currentGreeting) {
      // Set a timer to start deleting
      timer = setTimeout(() => {
        setIsDeletingGreeting(true);
      }, pauseDuration);
      
    // If we've deleted everything
    } else if (isDeletingGreeting && greetingText === '') {
      setIsDeletingGreeting(false);
      setGreetingPhase((prev) => (prev + 1) % greetings.length);
      
    // Regular typing/deleting
    } else {
      timer = setTimeout(() => {
        setGreetingText(prev => {
          if (isDeletingGreeting) {
            return prev.substring(0, prev.length - 1);
          } else {
            return currentGreeting.substring(0, prev.length + 1);
          }
        });
      }, typingSpeed);
    }
    
    return () => clearTimeout(timer);
  }, [greetingText, isDeletingGreeting, greetingPhase, greetings]);

  // Completely rewritten subtitle animation effect with forced progression
  useEffect(() => {
    const typeSpeed = 50;
    const deleteSpeed = 30;
    const pauseBeforeDelete = 1500;
    
    let timer;
    
    const currentPhrase = textPhrases[textPhase];
    
    // Complete typing phase - text is fully typed out
    if (!isDeleting && subtitleText === currentPhrase) {
      timer = setTimeout(() => {
        // Force state update to start deleting
        setIsDeleting(true);
      }, pauseBeforeDelete);
    } 
    // Complete deleting phase - text is fully deleted
    else if (isDeleting && subtitleText === '') {
      // Move to next phrase
      const nextPhase = (textPhase + 1) % textPhrases.length;
      setTextPhase(nextPhase);
      setIsDeleting(false);
    } 
    // During typing
    else {
      timer = setTimeout(() => {
        if (isDeleting) {
          // Delete one character at a time
          setSubtitleText(subtitleText.slice(0, -1));
        } else {
          // Type one character at a time
          const nextChar = currentPhrase.charAt(subtitleText.length);
          setSubtitleText(subtitleText + nextChar);
        }
      }, isDeleting ? deleteSpeed : typeSpeed);
    }
    
    return () => clearTimeout(timer);
  }, [subtitleText, isDeleting, textPhase, textPhrases]);

  return (
    <div className="profile-section">
      <div className="site-nav">
        <div className="nav-links">
          <a href="https://github.com/jxshuaa" target="_blank" rel="noopener noreferrer">projects</a>
          <a href="https://e-z.bio/jxsh" target="_blank" rel="noopener noreferrer">my e-z.bio</a>
          <a href="https://discord.gg/UWFH2sEfCW" target="_blank" rel="noopener noreferrer">carbon softworks</a>
        </div>
      </div>

      <div className="profile-header">
        <div className="profile-title">
          <h1 className="profile-name">
            <span className="greeting-text">{greetingText}</span>
            <span className="greeting-cursor">|</span>
          </h1>
          <div className="profile-subtitle">
            <span className="typed-subtitle">{subtitleText}</span>
            <span className="subtitle-cursor">|</span>
          </div>
        </div>
      </div>
      
      <div className="content-container">
        <div className="main-column">
          <DiscordStatus />
          
          <div className="skills-section">
            <div className="skill-icons">
              <span className="skill-icon">
                <FaPython />
              </span>
              <span className="skill-icon">
                <SiJavascript />
              </span>
              <span className="skill-icon">
                <FaReact />
              </span>
              <span className="skill-icon">
                <SiMongodb />
              </span>
            </div>
            
            <div className="volume-control">
              <span className="volume-icon">🔊</span>
              <input
                type="range"
                min="0"
                max="100"
                value={volume}
                onChange={handleVolumeChange}
                className="volume-slider"
              />
              <span className="volume-level">{volume}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSection; 